import { xingConnect } from '@xingternal/frame-data-provider';
// @ts-ignore
import selectSearch from './selectors';
// @ts-ignore
import SearchBar from './SearchBar';
export default xingConnect(selectSearch)(SearchBar);
//# sourceMappingURL=SearchBar.container.js.map